/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  DeleteApiV1SsoimageId200,
  DeleteApiV1SsoimageId400,
  DeleteApiV1SsoimageId401,
  DeleteApiV1SsoimageId500,
  DeleteApiV1SsoimageIdMutationResponse,
  DeleteApiV1SsoimageIdPathParams,
} from "../../types/SSOImageController/DeleteApiV1SsoimageId.ts";

export const deleteApiV1SsoimageIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<DeleteApiV1SsoimageIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const deleteApiV1SsoimageId200Schema =
  z.any() as unknown as ToZod<DeleteApiV1SsoimageId200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const deleteApiV1SsoimageId400Schema =
  z.any() as unknown as ToZod<DeleteApiV1SsoimageId400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const deleteApiV1SsoimageId401Schema =
  z.any() as unknown as ToZod<DeleteApiV1SsoimageId401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const deleteApiV1SsoimageId500Schema =
  z.any() as unknown as ToZod<DeleteApiV1SsoimageId500>;

export const deleteApiV1SsoimageIdMutationResponseSchema = z.lazy(
  () => deleteApiV1SsoimageId200Schema,
) as unknown as ToZod<DeleteApiV1SsoimageIdMutationResponse>;
